<pl-widget [heading]="heading" (editModeChanged)="onEdit($event)"></pl-widget>

